import profileImg from "../img/profile.png";

export default function Banner() {
  return (
    <section className="min-h-screen flex flex-col py-8 md:py-12">
      {/* Navigation */}
      <nav className="flex justify-between items-center mb-12 animate-fade-in">
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 rounded-full bg-accent"></div>
          <span className="text-overline uppercase text-subtle tracking-widest">
            Nicolai Herforth
          </span>
        </div>
        <div className="flex items-center space-x-8 text-caption">
          <a href="#thesis" className="text-muted hover:text-foreground transition-colors link-animate no-underline">
            Thesis
          </a>
          <a href="#building" className="text-muted hover:text-foreground transition-colors link-animate no-underline">
            Building
          </a>
          <a href="#contact" className="text-muted hover:text-foreground transition-colors link-animate no-underline">
            Contact
          </a>
        </div>
      </nav>

      {/* Hero - Bold and confident */}
      <div className="flex-1 flex flex-col justify-center">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-4 items-center">

          {/* Name - MASSIVE */}
          <div className="lg:col-span-7 order-2 lg:order-1">
            {/* Overline */}
            <div className="flex items-center gap-4 mb-6 animate-slide-in-right">
              <div className="w-16 h-1.5 bg-accent"></div>
              <p className="text-caption uppercase text-subtle tracking-widest">
                Co-founder, Precurion
              </p>
            </div>

            {/* The name */}
            <h1 className="text-display-xl mb-8 animate-fade-in-up delay-100">
              Nicolai<br />
              Herforth
            </h1>

            {/* Thesis hook - also bold */}
            <p className="text-statement text-muted max-w-xl mb-12 animate-fade-in-up delay-200">
              Execution is a commodity.<br />
              <span className="text-foreground">The new challenge is trust.</span>
            </p>

            {/* CTA - with animated arrow */}
            <div className="flex items-center gap-8 animate-fade-in-up delay-300">
              <a
                href="#thesis"
                className="group inline-flex items-center gap-4 px-6 py-4 bg-foreground text-background text-caption font-medium uppercase tracking-widest no-underline rounded-sm hover:bg-accent-ink hover:text-background btn-magnetic"
              >
                <span>Read My Thesis</span>
                <svg className="w-4 h-4 transform transition-transform duration-200 group-hover:translate-x-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
            </div>
          </div>

          {/* Profile photo - larger, more integrated */}
          <div className="lg:col-span-5 order-1 lg:order-2 flex justify-center lg:justify-end animate-scale-in delay-100">
            <div className="relative">
              {/* Accent block behind - committed */}
              <div className="absolute -top-8 -right-8 w-40 h-40 bg-accent/40"></div>

              {/* Corner accents - bolder */}
              <div className="absolute -top-3 -left-3 w-16 h-16 border-t-3 border-l-3 border-accent"></div>

              {/* Image - larger */}
              <img
                src={profileImg}
                alt="Nicolai Herforth"
                className="relative w-64 sm:w-72 md:w-80 lg:w-96 object-contain"
              />

              {/* Corner accent - bottom */}
              <div className="absolute -bottom-3 -right-3 w-16 h-16 border-b-3 border-r-3 border-accent"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator - links to the next section */}
      <div className="flex justify-center pt-8 animate-fade-in delay-500">
        <a href="#thesis" className="flex flex-col items-center gap-2 text-subtle hover:text-foreground no-underline">
          <span className="text-label uppercase tracking-widest">Scroll</span>
          <span className="relative w-px h-12 bg-border overflow-hidden">
            <span className="absolute top-0 left-0 w-full h-4 bg-accent animate-scroll-pulse"></span>
          </span>
        </a>
      </div>
    </section>
  );
}
